import { type FC } from 'react'
import classNames from 'classnames'
import { type SaveBarNotice } from './saveBarNotice'
import styles from './SaveBarNoticeStrip.module.scss'

interface SaveBarNoticeStripProps {
  notice: SaveBarNotice
  onDismiss: () => void
  onContactSupport: () => void
}

export const SaveBarNoticeStrip: FC<SaveBarNoticeStripProps> = ({ notice, onDismiss, onContactSupport }) => {
  const isError = notice.variant === 'error'
  return (
    <div className='d-flex align-items-center justify-content-center position-relative py-3 px-5 zocks-gap-1'>
      {isError ? (
        <i className='bi bi-exclamation-circle-fill fs-4 zocks-text-danger-200' />
      ) : (
        <span className={classNames('d-flex align-items-center justify-content-center rounded-circle p-1', styles.successIconCircle)}>
          <i className='bi bi-check-circle-fill fs-6 zocks-text-success' />
        </span>
      )}
      <span className={classNames('fw-bold', isError ? 'zocks-text-danger-200' : 'zocks-text-success-200')}>
        {notice.message}
        {notice.withContactSupport ? (
          <>
            {' Try again or '}
            <button
              type='button'
              className={classNames('btn p-0 border-0 fw-bold align-baseline text-decoration-underline', styles.supportLink)}
              onClick={onContactSupport}
            >
              contact support.
            </button>
          </>
        ) : null}
      </span>
      <button
        type='button'
        aria-label='Dismiss'
        className='btn d-flex p-0 border-0 position-absolute top-50 end-0 translate-middle-y me-4 lh-1'
        onClick={onDismiss}
      >
        <i className='bi bi-x fs-4' />
      </button>
    </div>
  )
}
